var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observer } from "mobx-react";
import { Label } from 'reactstrap';
import { Modal } from '@app/Components/Modal/Modal';
import { action, observable } from 'mobx';
import React from "react";
import { NorrdProjectPicker } from "@app/Components/Pickers/NorrdProjectPicker/NorrdProjectPicker";
import { ConfirmationDialog } from "../ConfirmationDialog/ConfirmationDialog";
import { Api } from "@app/Api";
export var LinkNorrdProjectModal = /** @class */ (function (_super) {
    __extends(LinkNorrdProjectModal, _super);
    function LinkNorrdProjectModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._norrdProjectId = null;
        _this._isConfirmationDialogOpen = false;
        return _this;
    }
    LinkNorrdProjectModal.prototype._toggleModal = function () {
        this.props.onToggle();
    };
    LinkNorrdProjectModal.prototype._handleNorrdProjectChange = function (norrdProjectId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._norrdProjectId = norrdProjectId ? parseInt(norrdProjectId) : null;
                return [2 /*return*/];
            });
        });
    };
    LinkNorrdProjectModal.prototype._handleLinkClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._toggleConfirmationDialogOpen();
                return [2 /*return*/];
            });
        });
    };
    LinkNorrdProjectModal.prototype._handleSaveLinkClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projectId, onSave;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this._norrdProjectId) {
                            return [2 /*return*/];
                        }
                        projectId = (_a = this.props, _a.projectId), onSave = _a.onSave;
                        return [4 /*yield*/, Api.secured.linkAndSynchronizeWithNorrdProject({ norrdProjectId: this._norrdProjectId, projectId: projectId })];
                    case 1:
                        _b.sent();
                        this._toggleConfirmationDialogOpen();
                        this._toggleModal();
                        return [4 /*yield*/, (onSave === null || onSave === void 0 ? void 0 : onSave())];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LinkNorrdProjectModal.prototype._toggleConfirmationDialogOpen = function () {
        this._isConfirmationDialogOpen = !this._isConfirmationDialogOpen;
    };
    LinkNorrdProjectModal.prototype._getFooterButtons = function (isFormValid) {
        return [
            {
                color: 'success',
                disabled: !isFormValid,
                onClick: this._handleLinkClick,
                title: 'Link'
            },
            {
                onClick: this._toggleModal,
                title: 'Close'
            }
        ];
    };
    LinkNorrdProjectModal.prototype.render = function () {
        var _this = this;
        var isOpen = this.props.isOpen;
        var isFormValid = !!this._norrdProjectId;
        return (React.createElement(React.Fragment, null,
            React.createElement(Modal, { isOpen: isOpen, headerTitle: "Link NORRD Project", toggle: this._toggleModal, minWidth: '600px', footerbuttons: this._getFooterButtons(isFormValid) },
                React.createElement("div", null,
                    React.createElement(Label, null, "NORRD Project"),
                    React.createElement(NorrdProjectPicker, { projectId: this.props.projectId, showDisplayName: true, onChangeHandler: function (x) { return _this._handleNorrdProjectChange(x === null || x === void 0 ? void 0 : x.value); }, isClearable: true }))),
            React.createElement(ConfirmationDialog, { isOpen: this._isConfirmationDialogOpen, onToggle: this._toggleConfirmationDialogOpen, headerTitle: "Link NORRD project", okButtonTitle: "Link", onSave: this._handleSaveLinkClick, body: "Do you really want to link NORRD project?", maxWidth: "400px" })));
    };
    __decorate([
        observable
    ], LinkNorrdProjectModal.prototype, "_norrdProjectId", void 0);
    __decorate([
        observable
    ], LinkNorrdProjectModal.prototype, "_isConfirmationDialogOpen", void 0);
    __decorate([
        action.bound
    ], LinkNorrdProjectModal.prototype, "_toggleModal", null);
    __decorate([
        action.bound
    ], LinkNorrdProjectModal.prototype, "_handleNorrdProjectChange", null);
    __decorate([
        action.bound
    ], LinkNorrdProjectModal.prototype, "_handleLinkClick", null);
    __decorate([
        action.bound
    ], LinkNorrdProjectModal.prototype, "_handleSaveLinkClick", null);
    __decorate([
        action.bound
    ], LinkNorrdProjectModal.prototype, "_toggleConfirmationDialogOpen", null);
    LinkNorrdProjectModal = __decorate([
        observer
    ], LinkNorrdProjectModal);
    return LinkNorrdProjectModal;
}(React.Component));
